import { COUNTRY_PHONE_CODES } from "./countryPhoneCodes";

export interface CountryData {
  code: string;
  label: string;
  countryCode: string;
  flagPath: string;
  region?: string;
}

// Map countries to regions with sub-regions
// Format: "Region / Sub-Region"
const COUNTRY_REGIONS: Record<string, string> = {
  // North America
  US: "Americas / North America",
  CA: "Americas / North America",
  MX: "Americas / North America",

  // Central America & Caribbean
  AG: "Americas / Central America & Caribbean",
  AI: "Americas / Central America & Caribbean",
  AW: "Americas / Central America & Caribbean",
  BB: "Americas / Central America & Caribbean",
  BL: "Americas / Central America & Caribbean",
  BM: "Americas / Central America & Caribbean",
  BQ: "Americas / Central America & Caribbean",
  BS: "Americas / Central America & Caribbean",
  BZ: "Americas / Central America & Caribbean",
  CR: "Americas / Central America & Caribbean",
  CU: "Americas / Central America & Caribbean",
  CW: "Americas / Central America & Caribbean",
  DM: "Americas / Central America & Caribbean",
  DO: "Americas / Central America & Caribbean",
  GD: "Americas / Central America & Caribbean",
  GP: "Americas / Central America & Caribbean",
  GT: "Americas / Central America & Caribbean",
  HN: "Americas / Central America & Caribbean",
  HT: "Americas / Central America & Caribbean",
  JM: "Americas / Central America & Caribbean",
  KN: "Americas / Central America & Caribbean",
  KY: "Americas / Central America & Caribbean",
  LC: "Americas / Central America & Caribbean",
  MF: "Americas / Central America & Caribbean",
  MQ: "Americas / Central America & Caribbean",
  MS: "Americas / Central America & Caribbean",
  NI: "Americas / Central America & Caribbean",
  PA: "Americas / Central America & Caribbean",
  PR: "Americas / Central America & Caribbean",
  SV: "Americas / Central America & Caribbean",
  SX: "Americas / Central America & Caribbean",
  TC: "Americas / Central America & Caribbean",
  TT: "Americas / Central America & Caribbean",
  VC: "Americas / Central America & Caribbean",
  VG: "Americas / Central America & Caribbean",
  VI: "Americas / Central America & Caribbean",

  // South America
  AR: "Americas / South America",
  BO: "Americas / South America",
  BR: "Americas / South America",
  CL: "Americas / South America",
  CO: "Americas / South America",
  EC: "Americas / South America",
  FK: "Americas / South America",
  GF: "Americas / South America",
  GY: "Americas / South America",
  PE: "Americas / South America",
  PY: "Americas / South America",
  SR: "Americas / South America",
  UY: "Americas / South America",
  VE: "Americas / South America",

  // Europe - Northern
  AX: "Europe / Northern Europe",
  DK: "Europe / Northern Europe",
  EE: "Europe / Northern Europe",
  FI: "Europe / Northern Europe",
  FO: "Europe / Northern Europe",
  GB: "Europe / Northern Europe",
  GG: "Europe / Northern Europe",
  IE: "Europe / Northern Europe",
  IM: "Europe / Northern Europe",
  IS: "Europe / Northern Europe",
  JE: "Europe / Northern Europe",
  LT: "Europe / Northern Europe",
  LV: "Europe / Northern Europe",
  NO: "Europe / Northern Europe",
  SE: "Europe / Northern Europe",

  // Europe - Southern
  AD: "Europe / Southern Europe",
  AL: "Europe / Southern Europe",
  BA: "Europe / Southern Europe",
  CY: "Europe / Southern Europe",
  ES: "Europe / Southern Europe",
  GI: "Europe / Southern Europe",
  GR: "Europe / Southern Europe",
  HR: "Europe / Southern Europe",
  IT: "Europe / Southern Europe",
  MC: "Europe / Southern Europe",
  ME: "Europe / Southern Europe",
  MK: "Europe / Southern Europe",
  MT: "Europe / Southern Europe",
  PT: "Europe / Southern Europe",
  RS: "Europe / Southern Europe",
  SI: "Europe / Southern Europe",
  SM: "Europe / Southern Europe",
  VA: "Europe / Southern Europe",
  XK: "Europe / Southern Europe",

  // Europe - Western
  AT: "Europe / Western Europe",
  BE: "Europe / Western Europe",
  CH: "Europe / Western Europe",
  DE: "Europe / Western Europe",
  FR: "Europe / Western Europe",
  LI: "Europe / Western Europe",
  LU: "Europe / Western Europe",
  NL: "Europe / Western Europe",

  // Europe - Eastern
  BG: "Europe / Eastern Europe",
  BY: "Europe / Eastern Europe",
  CZ: "Europe / Eastern Europe",
  GE: "Europe / Eastern Europe",
  HU: "Europe / Eastern Europe",
  MD: "Europe / Eastern Europe",
  PL: "Europe / Eastern Europe",
  RO: "Europe / Eastern Europe",
  RU: "Europe / Eastern Europe",
  SK: "Europe / Eastern Europe",
  UA: "Europe / Eastern Europe",

  // Africa - Northern
  DZ: "Africa / Northern Africa",
  EG: "Africa / Northern Africa",
  EH: "Africa / Northern Africa",
  LY: "Africa / Northern Africa",
  MA: "Africa / Northern Africa",
  SD: "Africa / Northern Africa",
  TN: "Africa / Northern Africa",

  // Africa - Western
  BJ: "Africa / Western Africa",
  BF: "Africa / Western Africa",
  CV: "Africa / Western Africa",
  CI: "Africa / Western Africa",
  GM: "Africa / Western Africa",
  GH: "Africa / Western Africa",
  GN: "Africa / Western Africa",
  GW: "Africa / Western Africa",
  LR: "Africa / Western Africa",
  ML: "Africa / Western Africa",
  MR: "Africa / Western Africa",
  NE: "Africa / Western Africa",
  NG: "Africa / Western Africa",
  SH: "Africa / Western Africa",
  SN: "Africa / Western Africa",
  SL: "Africa / Western Africa",
  TG: "Africa / Western Africa",

  // Africa - Central
  AO: "Africa / Central Africa",
  CF: "Africa / Central Africa",
  CG: "Africa / Central Africa",
  CD: "Africa / Central Africa",
  CM: "Africa / Central Africa",
  GA: "Africa / Central Africa",
  GQ: "Africa / Central Africa",
  ST: "Africa / Central Africa",
  TD: "Africa / Central Africa",

  // Africa - Eastern
  BI: "Africa / Eastern Africa",
  KM: "Africa / Eastern Africa",
  DJ: "Africa / Eastern Africa",
  ER: "Africa / Eastern Africa",
  ET: "Africa / Eastern Africa",
  KE: "Africa / Eastern Africa",
  MG: "Africa / Eastern Africa",
  MW: "Africa / Eastern Africa",
  MU: "Africa / Eastern Africa",
  MZ: "Africa / Eastern Africa",
  RE: "Africa / Eastern Africa",
  RW: "Africa / Eastern Africa",
  SC: "Africa / Eastern Africa",
  SO: "Africa / Eastern Africa",
  SS: "Africa / Eastern Africa",
  TZ: "Africa / Eastern Africa",
  UG: "Africa / Eastern Africa",
  YT: "Africa / Eastern Africa",
  ZM: "Africa / Eastern Africa",
  ZW: "Africa / Eastern Africa",

  // Africa - Southern
  BW: "Africa / Southern Africa",
  LS: "Africa / Southern Africa",
  NA: "Africa / Southern Africa",
  ZA: "Africa / Southern Africa",
  SZ: "Africa / Southern Africa",

  // Middle East
  AE: "Middle East & Central Asia / Middle East",
  BH: "Middle East & Central Asia / Middle East",
  IR: "Middle East & Central Asia / Middle East",
  IQ: "Middle East & Central Asia / Middle East",
  IL: "Middle East & Central Asia / Middle East",
  JO: "Middle East & Central Asia / Middle East",
  KW: "Middle East & Central Asia / Middle East",
  LB: "Middle East & Central Asia / Middle East",
  OM: "Middle East & Central Asia / Middle East",
  PS: "Middle East & Central Asia / Middle East",
  QA: "Middle East & Central Asia / Middle East",
  SA: "Middle East & Central Asia / Middle East",
  SY: "Middle East & Central Asia / Middle East",
  TR: "Middle East & Central Asia / Middle East",
  YE: "Middle East & Central Asia / Middle East",

  // Central Asia
  AF: "Middle East & Central Asia / Central Asia",
  AM: "Middle East & Central Asia / Central Asia",
  AZ: "Middle East & Central Asia / Central Asia",
  KZ: "Middle East & Central Asia / Central Asia",
  KG: "Middle East & Central Asia / Central Asia",
  TJ: "Middle East & Central Asia / Central Asia",
  TM: "Middle East & Central Asia / Central Asia",
  UZ: "Middle East & Central Asia / Central Asia",

  // Asia - South
  BD: "Asia / South Asia",
  BT: "Asia / South Asia",
  IN: "Asia / South Asia",
  LK: "Asia / South Asia",
  MV: "Asia / South Asia",
  NP: "Asia / South Asia",
  PK: "Asia / South Asia",

  // Asia - Southeast
  BN: "Asia / Southeast Asia",
  KH: "Asia / Southeast Asia",
  ID: "Asia / Southeast Asia",
  LA: "Asia / Southeast Asia",
  MY: "Asia / Southeast Asia",
  MM: "Asia / Southeast Asia",
  PH: "Asia / Southeast Asia",
  SG: "Asia / Southeast Asia",
  TH: "Asia / Southeast Asia",
  TL: "Asia / Southeast Asia",
  VN: "Asia / Southeast Asia",

  // Asia - East
  CN: "Asia / East Asia",
  HK: "Asia / East Asia",
  JP: "Asia / East Asia",
  KP: "Asia / East Asia",
  KR: "Asia / East Asia",
  MO: "Asia / East Asia",
  MN: "Asia / East Asia",
  TW: "Asia / East Asia",

  // Oceania
  AS: "Oceania / Oceania",
  AU: "Oceania / Oceania",
  CK: "Oceania / Oceania",
  FJ: "Oceania / Oceania",
  FM: "Oceania / Oceania",
  GU: "Oceania / Oceania",
  KI: "Oceania / Oceania",
  MH: "Oceania / Oceania",
  MP: "Oceania / Oceania",
  NC: "Oceania / Oceania",
  NF: "Oceania / Oceania",
  NR: "Oceania / Oceania",
  NU: "Oceania / Oceania",
  NZ: "Oceania / Oceania",
  PF: "Oceania / Oceania",
  PG: "Oceania / Oceania",
  PN: "Oceania / Oceania",
  PW: "Oceania / Oceania",
  SB: "Oceania / Oceania",
  TK: "Oceania / Oceania",
  TO: "Oceania / Oceania",
  TV: "Oceania / Oceania",
  VU: "Oceania / Oceania",
  WF: "Oceania / Oceania",
  WS: "Oceania / Oceania",

  // Other territories
  AQ: "Other / Antarctica",
  BV: "Other / Antarctica",
  CC: "Other / Special Territories",
  CX: "Other / Special Territories",
  GL: "Other / Arctic Territories",
  GS: "Other / Special Territories",
  HM: "Other / Special Territories",
  IO: "Other / Special Territories",
  PM: "Other / Special Territories",
  SJ: "Other / Arctic Territories",
  TF: "Other / Special Territories",
  UM: "Other / Special Territories",
};

/**
 * Parse country code and name from flag filename
 * Format: "XX - Country Name.svg" or "XXX - Country Name.svg" or "XX-YYY - Country Name.svg"
 * Handles both standard codes (GB) and regional variants (GB-UKM, BQ-BO, etc.)
 */
function parseCountryFromFilename(filename: string): { countryCode: string; countryName: string } | null {
  const match = filename.match(/^([A-Z]{2,3})(?:-[A-Z]+)?\s*-\s*(.+?)\.svg$/);
  if (!match) return null;

  // Extract base country code (first 2 letters only for regional variants)
  let countryCode = match[1];
  if (countryCode.length === 3) {
    // Keep 3-letter codes like ALA for Åland Islands
    countryCode = countryCode;
  } else {
    // For 2-letter codes, use as-is
    countryCode = countryCode;
  }

  return {
    countryCode,
    countryName: match[2].trim()
  };
}

/**
 * Generate country codes list from available flags
 * This creates the full list of countries that can be used for recovery
 * Handles multiple variants per country code (e.g., GB-ENG, GB-UKM, etc.)
 */
export function generateCountryCodesList(flagFilenames: string[]): CountryData[] {
  const countries: CountryData[] = [];

  // Group filenames by country code to handle variants
  const byCountryCode: Record<string, Array<{ filename: string; countryName: string }>> = {};

  for (const filename of flagFilenames) {
    const parsed = parseCountryFromFilename(filename);
    if (!parsed) continue;

    const { countryCode, countryName } = parsed;
    if (!byCountryCode[countryCode]) {
      byCountryCode[countryCode] = [];
    }
    byCountryCode[countryCode].push({ filename, countryName });
  }

  // Process each country code, selecting the best variant
  for (const [countryCode, variants] of Object.entries(byCountryCode)) {
    // Get phone code
    const phoneCode = COUNTRY_PHONE_CODES[countryCode];
    if (!phoneCode) {
      console.warn(`No phone code found for ${countryCode}`);
      continue;
    }

    // Select best variant for countries with multiple flag variants
    // (e.g., GB-ENG/GB-NIR/GB-SCT/GB-UKM/GB-WLS for United Kingdom)
    let selectedVariant = variants[0];

    if (variants.length > 1) {
      // Preferred variants for known multi-part countries
      const preferredNames: Record<string, string[]> = {
        GB: ["United Kingdom", "Kingdom"],  // Prefer GB-UKM
        KN: ["Saint Kitts and Nevis", "Kitts"],  // Prefer KN-SK
        MQ: ["Martinique"],  // Either MQ variant is fine, take first
        PM: ["Saint Pierre and Miquelon", "Pierre"],  // Prefer full name
      };

      // Try to find a variant matching preferred names
      if (preferredNames[countryCode]) {
        const preferred = variants.find(v =>
          preferredNames[countryCode].some(name =>
            v.countryName.includes(name)
          )
        );
        if (preferred) {
          selectedVariant = preferred;
        }
      }

      // Otherwise prefer base variant (no hyphen after country code)
      if (!preferredNames[countryCode]) {
        const baseVariant = variants.find(v => {
          const match = v.filename.match(/^([A-Z]{2,3})\s*-\s*.+\.svg$/);
          return match && !v.filename.includes(`${match[1]}-`);
        });
        if (baseVariant) {
          selectedVariant = baseVariant;
        }
      }
    }

    const { filename, countryName } = selectedVariant;
    const region = COUNTRY_REGIONS[countryCode] || "Other";

    countries.push({
      code: phoneCode,
      label: `${countryName} (${phoneCode})`,
      countryCode,
      flagPath: `/icons/flags/M/${filename}`,
      region
    });
  }

  // Sort by region, then by country name
  countries.sort((a, b) => {
    if (a.region !== b.region) {
      return (a.region ?? "").localeCompare(b.region ?? "");
    }
    return a.label.localeCompare(b.label);
  });

  return countries;
}

/**
 * Get all available flag filenames
 * In development, this is imported from a generated manifest
 */
export async function getAllFlagFilenames(): Promise<string[]> {
  try {
    const response = await fetch("/icons/flags/manifest.json");
    if (response.ok) {
      const data = await response.json();
      return data.flags || [];
    }
  } catch (err) {
    console.warn("Could not load flag manifest, using hardcoded list");
  }

  // Fallback: hardcoded list (will be replaced by manifest)
  return [];
}
